export const CONSENT_KEY = "lexv_cookie_consent";
// Device-only extras a visitor can refuse; sign-in, settings and account sync stay on
const OPTIONAL_KEYS = ["lexv_practice_progress", "lexv_activity"];

export const getConsent = () => localStorage.getItem(CONSENT_KEY);
export const optionalAllowed = () => getConsent() !== "declined";
export const setConsent = (v) => {
  localStorage.setItem(CONSENT_KEY, v);
  if (v === "declined") OPTIONAL_KEYS.forEach((k) => localStorage.removeItem(k));
  window.dispatchEvent(new Event("lexv-consent"));
};
export const clearAllLocal = () => Object.keys(localStorage).filter((k) => k.startsWith("lexv_") && k !== CONSENT_KEY).forEach((k) => localStorage.removeItem(k));
